import React from 'react';

import './footer.scss';

const Footer = ({ isMobile }) => {
  return (
    <div className={`footer-container ${isMobile ? 'mobile-footer' : ''}`}>
      © {new Date().getFullYear()} Doselect. All rights reserved.
    </div>
  );
};

export default Footer;
